import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '@common/analytics';
import classes from '../classes.module.scss';
import {
  getTopSection, renderGeneralMessage
} from './processing_status_utils';
import { setMessageToAppData } from '../../../actions/message_to_app';
import { messageToAppKeys } from '../../../../common/message_to_app_handler';
import { getPurchaseFailedPropsForMobileApp } from '../purchases_utils';
import { PurchaseSvgIcon } from '../../../../common/sprites';

const trackPageVisitHandler = (okMessage, isAffiliatePromoPopup, errorType) => {
  if (okMessage && !isAffiliatePromoPopup) analyticsService.trackPageVisit('payment received popup');
  if (errorType === 'spending_limits') analyticsService.trackPageVisit('increase spending limit popup');
};

function MobileProcessingStatus({
  purchaseResponce = {},
  t,
  isCreditCard = false,
  isAffiliatePromoPopup,
  purchaseAmount,
  bonus = 0,
  error = null,
  type,
  currentPaymentOption,
  purchaseFees,
  chatType
}) {
  const location = useLocation();
  const {
    okMessage, errorMessage, errorType
  } = purchaseResponce || {};
  useEffect(() => {
    trackPageVisitHandler(okMessage, isAffiliatePromoPopup, errorType);
  }, [errorType, okMessage]);

  useEffect(() => {
    if (errorMessage) {
      const purchaseFailedProps = getPurchaseFailedPropsForMobileApp({
        ...purchaseResponce, type, purchaseAmount, bonus, currentPaymentOption, purchaseFees, chatType, location
      });
      window.store.dispatch(setMessageToAppData({
        sentToAppMessage: {
          [messageToAppKeys.action]: messageToAppKeys.analytics,
          [messageToAppKeys.params]: {
            analytic_events: {
              'purchase failed': {
                ...purchaseFailedProps
              }
            }
          }
        }
      }));
    }
  }, [errorMessage]);

  const onErrorClick = () => {
    if (errorType === 'spending_limits') {
      window.store.dispatch(setMessageToAppData({
        sentToAppMessage: {
          [messageToAppKeys.action]: messageToAppKeys.navigationUpdate,
          [messageToAppKeys.params]: {
            [messageToAppKeys.route]: 'spending_limit'
          }
        }
      }));
    }
    window.store.dispatch(setMessageToAppData({
      sentToAppMessage: {
        [messageToAppKeys.action]: messageToAppKeys.dismiss
      }
    }));
  };

  const getErrorButtonTitle = () => {
    if (errorType === 'spending_limits') return t('paypal_purchase.increase_spending_limits');
    return t('general.ok');
  };

  const errorButton = () => {
    if (errorMessage || error) {
      return (
        <div className={ classes.botomContainer }>
          <div className={ classes.errorButtonContainer }>
            <button
              type="button"
              className={ classes.errorA }
              onClick={ onErrorClick }
            >
              <div className={ classes.confirmButtonA }>
                { getErrorButtonTitle() }
              </div>
            </button>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderErrorIcon = () => {
    if (!errorMessage) return null;
    return (
      <PurchaseSvgIcon
        id="mobile_processing_status_error_icon"
        className={ classes.topImage }
      />
    );
  };

  const renderProcessingStatus = () => {
    const checkedOkMessage = currentPaymentOption?.kind === 'gp' && okMessage ? '' : okMessage; // for google pay, we don't need to show the ok message
    return (
      <div className={ classes.dialogContainerMobile }>
        { renderErrorIcon() }
        <div>
          { getTopSection({
            errorMessage, t, okMessage: checkedOkMessage,  isAffiliatePromoPopup, purchaseAmount, bonus
          }) }
        </div>
        <br className={ classes.dialogContainerBr } />
        <div style={ { display: 'flex' } }>
          { renderGeneralMessage({
            isAffiliatePromoPopup, okMessage: checkedOkMessage, bonus, errorMessage, error, isCreditCard, t
          }) }
        </div>
        <br className={ classes.dialogContainerBr } />
        <div className={ classes.bottomRowMobile }>
          { errorButton() }
        </div>
      </div>
    );
  };

  return renderProcessingStatus();
}

export default MobileProcessingStatus;
